/** 
* 自动生成文件，请勿修改 
* @name: 财务:现金流量表会计科目-费用类别对应关系模块
* @description: 现金流量表会计科目-费用类别对应关系管理==================现金流量表导出使用
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:8条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const cashSubCategRel = { 
	/** 1 summary:保存/修改-单条	method:post */ 
	saveOrUpd : new APIObject("/api/cashSubCategRel/saveOrUpd.do"), 
	/** 2 summary:查询-单条	method:post */ 
	queryOne : new APIObject("/api/cashSubCategRel/queryOne.do"), 
	/** 3 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/cashSubCategRel/delete.do"), 
	/** 4 summary:查询-分页	method:post */ 
	queryPage : new APIObject("/api/cashSubCategRel/queryPage.do"), 
	/** 5 summary:查询-全部不分页	method:post */ 
	queryAll : new APIObject("/api/cashSubCategRel/queryAll.do"), 
	/** 6 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/cashSubCategRel/batchDelete.do"), 
	/** 7 summary:绑定多个费用类别	method:post */ 
	bindCategorys : new APIObject("/api/cashSubCategRel/bindCategorys.do"), 
	/** 8 summary:保存/修改-批量	method:post */ 
	batchSaveOrUpd : new APIObject("/api/cashSubCategRel/batchSaveOrUpd.do"), 
};
export default cashSubCategRel;